export class CustomerUsage {
    customerUsageId: number;
    customerId: number;
    streamingUsage: number;
    lrsUsage: number;
    fileStorageUsage: number;
    userUsage: number;
}